import { Combobox } from "@/components/ui/Combobox";
import { State, type IState } from "country-state-city";
import { useMemo } from "react";

interface Props {
  placeholder?: string;
  onValueChange: ({ value, label }: { value: string; label: string }) => void;
  value?: string;
  countryCode: string;
}

export const StateCombobox = (props: Props): JSX.Element => {
  const states = useMemo(() => {
    return State.getStatesOfCountry(props.countryCode).map((state: IState) => ({
      value: state.isoCode,
      label: state.name,
    }));
  }, [props.countryCode]);

  return (
    <Combobox
      items={states}
      placeholder={props.placeholder}
      value={props.value}
      onValueChange={(value) => {
        props.onValueChange({ label: value.label, value: value.value });
      }}
    />
  );
};
